/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_4Inputs */

const en_pc_tut_open_4 = /** @type {(inputs: Pc_Tut_Open_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open several files at once. Each one gets a tab; right-click a tab to close it or reopen the last closed file.`)
};

const zh_pc_tut_open_4 = /** @type {(inputs: Pc_Tut_Open_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可同时打开多个文件，每个文件一个标签页；右键标签页可关闭或重新打开最近关闭的文件。`)
};

/**
* | output |
* | --- |
* | "Open several files at once. Each one gets a tab; right-click a tab to close it or reopen the last closed file." |
*
* @param {Pc_Tut_Open_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_4 = /** @type {((inputs?: Pc_Tut_Open_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_4(inputs)
	return zh_pc_tut_open_4(inputs)
});
export { pc_tut_open_4 as "pc.tut.open.4" }